export const mediaColorSchemeQuery = window.matchMedia(
  "(prefers-color-scheme: dark)",
);
